import { Step } from 'react-joyride';

export enum ActivityFeedJoyrideTarget {
  RESEARCH_TAB = 'joyrideTargetResearchTab',
  MEMBERS_TAB = 'joyrideTargetMembersTab'
}

export const activityFeedJoyrideSteps: {
  researchTab: Step;
  membersTab: Step;
} = {
  researchTab: {
    title: 'Research Tab',
    target: `[data-joyride-target="${ActivityFeedJoyrideTarget.RESEARCH_TAB}"]`,
    placement: 'right',
    content: 'Find investment ideas and research contests under the Research tab.',
    disableBeacon: true,
    disableOverlay: true,
    disableScrolling: true
  },
  membersTab: {
    title: 'Members Tab',
    target: `[data-joyride-target="${ActivityFeedJoyrideTarget.MEMBERS_TAB}"]`,
    placement: 'right',
    content: 'Use the Members tab to curate your network and follow Top Ranked Members.',
    disableBeacon: true,
    disableOverlay: true,
    disableScrolling: true
  }
};
